import { useContext } from 'react';

import { MagicContext } from './MagicContext';

export const useMagic = () => useContext(MagicContext);
